import application_settings from '../applicationSettings';
import Event from './Event';

class UserChangePassword extends Event {
    eventName = 'oms_userChangePassword';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for change password
     * 
     * @param {string} data.old_password -  old_password given for customer
     * @param {string} data.new_password -  new_password given for customer
     * @param {string} data.confirmed -  confirmed given for customer
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let oldPassword = data.old_password;
        let newPassword = data.new_password;
        let confirmed = data.confirmed;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (clientId && oldPassword && newPassword && confirmed) {

            // request data
            data.endPoint = application_settings.endPoints.userChangePassword;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.data = {
                old_password: oldPassword,
                new_password: newPassword,
                confirmed: confirmed
            };
        
            // send request
            this.sendRequest(data, function (response) {
              if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "client_id & oldPassword & newPassword & confirmed is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }


}

export default UserChangePassword;